import { Box } from '@mui/material';
import { altLevelIndex } from './altPlanContent';
import { ALTERNATE_SCALE } from './derive';
import { COLORS } from './tokens';

export function AltLadder({ level }: { level: number | null }) {
  const on = level != null ? altLevelIndex(level) : 0;
  return (
    <Box data-testid="alt-ladder" sx={{ display: 'flex', gap: '3px' }}>
      {Array.from({ length: ALTERNATE_SCALE.ladderSegments }, (_, i) => i + 1).map((seg) => (
        <Box
          key={seg}
          sx={{
            flex: 1,
            height: 6,
            borderRadius: '3px',
            bgcolor: seg <= on ? COLORS.navy : '#E3E3EA',
          }}
        />
      ))}
    </Box>
  );
}
